import { computed, DestroyRef } from '@angular/core';
import { mediaSignal } from '@core/utils/media.util';

export function createUpgraderGridBreakpoint(destroyRef: DestroyRef) {
  const isSmallScreen  = mediaSignal('(max-width: 640px)',  destroyRef);
  const isMdScreen     = mediaSignal('(max-width: 768px)',  destroyRef);
  const isLgScreen     = mediaSignal('(max-width: 1024px)', destroyRef);
  const isLargeDesktop = mediaSignal('(min-width: 1921px)', destroyRef);
  const isUltrawide    = mediaSignal('(min-width: 2560px)', destroyRef);

  return computed(() => {
    if (isSmallScreen())  return { columns: 3, pageSize: 15 };
    if (isMdScreen())     return { columns: 4, pageSize: 20 };
    if (isLgScreen())     return { columns: 5, pageSize: 25 };
    if (isUltrawide())    return { columns: 8, pageSize: 48 };
    if (isLargeDesktop()) return { columns: 6, pageSize: 30 };
    return                  { columns: 4, pageSize: 20 };
  });
}
